import { FavoriteMedicineDeleteCommand } from '@dreryk/egabinet-prescription-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import {
   dispatchSnackbarPositiveEvent,
   HeartIcon,
   IconFillColor,
   IconWrapper,
   RemoveIcon,
   Tooltip,
} from '@dreryk/react-components';

import { medicineSelectorTranslationKeys } from '../../../../../../translations';
import { FavoriteMedicineRestoreText } from '../FavoriteMedicineRestoreText/FavoriteMedicineRestoreText';

const DELETE_FAVORITE_MEDICINE_SNACKBAR_AUTO_HIDE_DELAY = 5000;

type FavoriteMedicineDeleteIconProps = {
   readonly medicineId: number;
   readonly onSuccess: VoidFunction;
   readonly medicineValid: boolean;
};

export const FavoriteMedicineDeleteIcon = (props: FavoriteMedicineDeleteIconProps): JSX.Element => {
   const { execute: removeFavoriteMedicine, loading: removeFavoriteMedicineLoading } = useCqrsCommand<void, void>(
      () => {
         const command = new FavoriteMedicineDeleteCommand();
         command.medicineId = props.medicineId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               props.medicineValid ? (
                  <FavoriteMedicineRestoreText medicineId={props.medicineId} onSuccess={props.onSuccess} />
               ) : (
                  medicineSelectorTranslationKeys.table.removedMedicineFromFavoritesWithoutRestore
               ),
               {
                  autoHideDelayInMs: DELETE_FAVORITE_MEDICINE_SNACKBAR_AUTO_HIDE_DELAY,
               }
            );
            props.onSuccess?.();
         },
      }
   );

   // TODO DREGAB-20163 Handle state without local useState, use refetch instead
   const handleClick = (): void => {
      if (!removeFavoriteMedicineLoading) {
         removeFavoriteMedicine();
      }
   };

   return (
      <Tooltip
         testId={'deleteFavoriteMedicine'}
         content={medicineSelectorTranslationKeys.table.removeMedicineFromFavorites}
      >
         <IconWrapper onClick={handleClick} fillColor={IconFillColor.PRIMARY} testId={'deleteFavoriteMedicine'}>
            {props.medicineValid ? <HeartIcon /> : <RemoveIcon />}
         </IconWrapper>
      </Tooltip>
   );
};
